import { Directive, HostListener, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../services/dialog.service';

@Directive({
  selector: '[lingUnsafeLinksHandler]',
  standalone: true,
})
export class UnsafeLinksHandlerDirective {
  private readonly translateService = inject(TranslateService);
  protected readonly dialogService = inject(DialogService);

  @HostListener('document:click', ['$event']) externalLinkListener(
    event: PointerEvent
  ) {
    const asElement = event.target as HTMLElement;

    const isAnchor = asElement.tagName === 'A';

    if (!isAnchor) {
      return;
    }

    const hrefValue = asElement.getAttribute('href');

    if (!hrefValue || !asElement.dataset['unsafeLink']) {
      return;
    }

    const safeOrigins = [
      location.origin,
      'https://lingon.io',
      'https://app.lingon.io',
    ];

    if (
      hrefValue?.startsWith('http') &&
      !safeOrigins.some((safeOrigin) => hrefValue?.startsWith(safeOrigin))
    ) {
      event.preventDefault();
      this.dialogService
        .open({
          title: this.translateService.instant(
            'dialogs.externalLinkClick.title'
          ),
          text: this.translateService.instant(
            'dialogs.externalLinkClick.text',
            { url: hrefValue }
          ),
          confirmButtonText: this.translateService.instant(
            'dialogs.externalLinkClick.confirmButtonText'
          ),
          rejectButtonText: this.translateService.instant(
            'dialogs.externalLinkClick.rejectButtonText'
          ),
        })
        .result.subscribe((isAllowed) => {
          if (isAllowed) {
            window.open(hrefValue, '_blank')?.focus();
          }
        });
    }
  }
}
